/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import InfiniteScrollMessages_patientRefetchable from "./InfiniteScrollMessages_patientRefetchable.graphql";
import { FragmentRefs } from "relay-runtime";
export type EnumMessageChannel = "chat" | "email" | "fax" | "inapp" | "sms" | "voice" | "whatsapp" | "%future added value";
export type EnumMessageType = "inbound" | "outbound" | "%future added value";
export type InfiniteScrollMessages_Patient = {
    readonly id: string;
    readonly _id: string;
    readonly name: string | null;
    readonly firstname: string | null;
    readonly lastname: string | null;
    readonly master: boolean | null;
    readonly avatar: string | null;
    readonly messagesConnection: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly _id: string;
                readonly oid_patient: string | null;
                readonly text: string | null;
                readonly type: EnumMessageType | null;
                readonly channel: EnumMessageChannel | null;
                readonly key: string | null;
                readonly externalId: {
                    readonly value: string | null;
                } | null;
                readonly externalStatus: {
                    readonly reason: string | null;
                } | null;
                readonly retry: {
                    readonly originalMessage: string | null;
                    readonly count: number | null;
                } | null;
                readonly oid_facility: string | null;
                readonly oid_createdBy: string | null;
                readonly oid_recipient: string | null;
                readonly " $fragmentRefs": FragmentRefs<"ChatMessage_Message">;
            };
        }>;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"ChatMessageTyping_Node">;
    readonly " $refType": "InfiniteScrollMessages_Patient";
};
export type InfiniteScrollMessages_Patient$data = InfiniteScrollMessages_Patient;
export type InfiniteScrollMessages_Patient$key = {
    readonly " $data"?: InfiniteScrollMessages_Patient$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"InfiniteScrollMessages_Patient">;
};



const node: ReaderFragment = (function(){
var v0 = [
  "messagesConnection"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": InfiniteScrollMessages_patientRefetchable,
      "identifierField": "id"
    }
  },
  "name": "InfiniteScrollMessages_Patient",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "master",
      "storageKey": null
    },
    {
      "alias": "avatar",
      "args": null,
      "kind": "ScalarField",
      "name": "oid_avatar",
      "storageKey": null
    },
    {
      "alias": "messagesConnection",
      "args": null,
      "concreteType": "MessageConnection",
      "kind": "LinkedField",
      "name": "__InfiniteScrollMessages_messagesConnection_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MessageEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Message",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "oid_patient",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "text",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "channel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MessageExternalId",
                  "kind": "LinkedField",
                  "name": "externalId",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "value",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MessageExternalStatus",
                  "kind": "LinkedField",
                  "name": "externalStatus",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "reason",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MessageRetry",
                  "kind": "LinkedField",
                  "name": "retry",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "originalMessage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "count",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "oid_facility",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "oid_createdBy",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "oid_recipient",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ChatMessage_Message"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChatMessageTyping_Node"
    }
  ],
  "type": "Patient",
  "abstractKey": null
};
})();
(node as any).hash = 'ee37a50939763bec7bf5214a581cd155';
export default node;
